'use client'

import Link from 'next/link';
import { t as systemText } from '../i18n';

export default function Error({ error, reset }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-page">
      <div className="max-w-md w-full bg-surface-card shadow-md rounded-lg p-6">
        <h1 className="text-xl font-bold text-red-600 dark:text-red-400 mb-4">{systemText("Error")}</h1>
        <p className="text-fg-tertiary mb-4">
          {error?.message || systemText("Something went wrong. Please try again.")}
        </p>
        <div className="space-y-2">
          <button
            onClick={() => reset()}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded transition-colors"
          >
            {systemText("Try again")}
          </button>
          <Link
            href="/"
            className="w-full bg-surface-strong hover:bg-gray-400 text-fg-strong px-4 py-2 rounded transition-colors block text-center"
          >
            {systemText("Go home")}
          </Link>
        </div>
        {process.env.NODE_ENV === 'development' && (
          <details className="mt-4">
            <summary className="cursor-pointer text-sm text-fg-muted">{systemText("Error details")}</summary>
            <pre className="mt-2 text-xs bg-surface-muted p-2 rounded overflow-auto max-h-32">
              {error?.stack}
            </pre>
          </details>
        )}
      </div>
    </div>
  )
}